import React from 'react';
import { useIntl } from 'react-intl';

import { renderWithBreaks } from '@utils/translations';

const ReportingChannelTab = () => {
  const intl = useIntl();

  return (
    <div>
      {renderWithBreaks(intl.formatMessage({ id: 'Reporting Channel text' }))}
    </div>
  );
}

export default ReportingChannelTab;
